import { render, staticRenderFns } from "./CreditsDetail.vue?vue&type=template&id=76278e38"
import script from "./CreditsDetail.vue?vue&type=script&lang=js"
export * from "./CreditsDetail.vue?vue&type=script&lang=js"
import style0 from "./CreditsDetail.vue?vue&type=style&index=0&id=76278e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports